import { Col, Row } from "reactstrap"
import logo from "../../../../assets/images/QN-logo-mini.png";
import moment from "moment";
import { formatCurrency } from "../../../../utils/formatCurrency";
import { startedCompanyId } from "../../../../utils/constants";


const InvoiceHeader = ({invoice, type, total}) => {
  return (
    <div className="invoice-header">
        <div className="d-flex justify-content-between align-items-center">
            <div>
                <h5 className="mb-1">{invoice.contract.company.name}</h5>
                <h5 className="mb-1">{invoice.contract.company.street} {invoice.contract.company.house_number}</h5>
                <h5 className="mb-1">{invoice.contract.company.postal_address_zip_code} {invoice.contract.company.postal_address_city}</h5>
                <h5 className="mb-1">{invoice.contract.company.postal_address_country}</h5>
                {/* <h5 className="mb-1">{invoice.contract.company.btw_number}</h5> */}
                {/* <h5 className="mb-1">{invoice.contract.company.kvk_number}</h5> */}
            </div>

            <div style={{ textAlign: "right" }}>
                <img src={logo} alt="" style={{ width: "120px" }} />
            </div>
        </div>

        <h3 className="mt-2 mb-4" style={{fontWeight: "bold", textAlign: "center"}}>
            {type == "invoice-details" ? "Invoice" : "Hours Sheet"}
        </h3>

        <Row className="g-3 mt-2 align-items-center">
            <Col xs={12} lg={2} className="print-total-amount">
                <div
                    className="amount-box w-100"
                    style={{ width: "fit-content" }}
                >
                    <span className="d-inline-block p-1 px-4 border-bottom">
                        Invoice Number
                    </span>
                    <span className="d-inline-block head px-4 py-2">
                        {invoice.id}
                    </span>
                </div>
            </Col>

            {type == 'invoice-details' && <Col xs={6} sm={3} lg={2} className="print-date">
                <div className="text-center">
                    <h6>Created At</h6>
                    <span>
                        {moment.utc(invoice.createdAt).format("DD MMM YYYY")}
                    </span>
                </div>
            </Col>}

            {type == 'invoice-details' && <Col xs={6} sm={3} lg={2} className="print-date">
                <div className="text-center">
                    <h6>Due Date</h6>
                    <span>
                        {moment.utc(invoice.date).format("DD MMM YYYY")}
                    </span>
                </div>
            </Col>}

            {type == 'hours-sheet' && <Col xs={6} sm={3} lg={2} className="print-date"></Col>}

            <Col xs={6} sm={3} lg={2} className="print-date">
                <div className="text-center">
                    <h6>From</h6>
                        {invoice.invoiceables?.length ? (
                    <span>
                        {moment.utc(
                        invoice.invoiceables[0].collection?.date_from
                        ).format("DD MMM YYYY")}
                    </span>
                    ) : (
                    "-"
                    )}
                </div>
            </Col>

            <Col xs={6} sm={3} lg={2} className="print-date">
                <div className="text-center">
                    <h6>To</h6>
                        {invoice.invoiceables?.length ? (
                    <span>
                        {moment.utc(
                        invoice.invoiceables[invoice.invoiceables?.length - 1]
                            .collection?.date_to
                        ).format("DD MMM YYYY")}
                    </span>
                    ) : (
                    "-"
                    )}
                </div>
            </Col>

            {type == 'hours-sheet' && <Col xs={6} sm={3} lg={2} className="print-date"></Col>}

            <Col xs={12} lg={2} className="print-total-amount">
                <div
                    className="amount-box ms-auto w-100"
                    style={{ width: "fit-content" }}
                >
                    <span className="d-inline-block p-1 px-4 border-bottom">
                        {type == "invoice-details" ? "Invoice Amount" : "Hours"}
                    </span>
                    <span className="d-inline-block head px-4 py-2">
                        {type == "invoice-details" ? formatCurrency(total) : total}
                    </span>
                </div>
            </Col>
        </Row>

        <div className="d-flex justify-content-between align-items-center flex-wrap mt-5">
            <h5 className="fs-14-print">Company Id: {startedCompanyId + invoice.contract.company.id}</h5>
            <h5 className="fs-14-print">Contract: {invoice?.contract?.jobTitle}</h5>
            <h5 className="fs-14-print">Pool: {invoice?.invoiceablesDays?.filter((inv) => inv?.collection_id)[0]?.poolName}</h5>
        </div>
    </div>
  )
}

export default InvoiceHeader